const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.hubscroll.app',
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
};


export default config;
